import React from 'react';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import ContentLoader from 'react-content-loader';

const useStyles = () =>
  createStyles({
    contentLoader: {
      backgroundColor: 'white',
      height: '100%',
      width: '100%',
    },
  });

export interface TableRects {
  rows: number;
  columns: number;
  spaceBetweenColumns?: number;
  spaceBetweenRows?: number;
  firstColumnWidth?: number;
  firstRowHeight?: number;
  firstSpaceBetweenColumn?: number;
  columnWidth: number;
  rowHeight: number;
  firstX?: number;
  firstY?: number;
}

interface GridContentLoaderProps extends WithStyles<typeof useStyles> {
  tableRects: TableRects;
  window: {
    width: number;
    height: number;
  };
}

const getTableRects = (tableRects: TableRects) => {
  const rects = [];
  const {
    rows,
    columns,
    spaceBetweenColumns = 0,
    spaceBetweenRows = 0,
    firstColumnWidth,
    firstRowHeight,
    firstSpaceBetweenColumn,
    columnWidth,
    rowHeight,
    firstX = 0,
    firstY = 0,
  } = tableRects;
  let nextY = 0;

  for (let row = 0; row < rows; row++) {
    const currentRowHeight = row === 0 && firstRowHeight ? firstRowHeight : rowHeight;
    const currentY = row === 0 ? firstY : nextY;
    let currentX = firstX;

    for (let column = 0; column < columns; column++) {
      const width = column === 0 && firstColumnWidth ? firstColumnWidth : columnWidth;
      const columnGap = column === 0 && firstSpaceBetweenColumn ? firstSpaceBetweenColumn : spaceBetweenColumns;

      rects.push(
        <rect
          key={`GridContentLoader-column-${currentX}-${currentY}`}
          x={currentX}
          y={currentY}
          rx="0"
          ry="0"
          width={width}
          height={currentRowHeight}
        />,
      );
      currentX += width + columnGap;
    }
    nextY = currentY + spaceBetweenRows + currentRowHeight;
  }
  return rects;
};

const GridContentLoader: React.FC<GridContentLoaderProps> = ({ classes, tableRects, window }) => {
  const rects = getTableRects(tableRects);
  const { width, height } = window;

  return (
    <ContentLoader
      className={classes.contentLoader}
      speed={2}
      style={{ width, height }}
      width={width}
      height={height}
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
    >
      {rects.map((rect) => rect)}
    </ContentLoader>
  );
};

export default withStyles(useStyles)(GridContentLoader);
